import { render } from "./ExpandableText.vue?vue&type=template&id=8ffe994a&scoped=true"
import script from "./ExpandableText.vue?vue&type=script&lang=js"
export * from "./ExpandableText.vue?vue&type=script&lang=js"

import "./ExpandableText.vue?vue&type=style&index=0&id=8ffe994a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ffe994a"]])

export default __exports__